// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UrF1","controls":"styles_controls__1AsZ7","charLimit":"styles_charLimit__23IYr","input":"styles_input__3g3oa","send":"styles_send__3qovN"};